export enum Currency {
  SGD = 'SGD',
  USD = 'USD',
  AUD = 'AUD',
  MYR = 'MYR',
  QAR = 'QAR',
  NZD = 'NZD',
  CAD = 'CAD',
  GBP = 'GBP',
  AED = 'AED',
  SAR = 'SAR',
  EUR = 'EUR',
  PLN = 'PLN',
  TRY = 'TRY',
  KZT = 'KZT',
  MNT = 'MNT',
  AZN = 'AZN',
  CHF = 'CHF',
  DKK = 'DKK',
  NOK = 'NOK',
  JPY = 'JPY',
  MXN = 'MXN',
  CLP = 'CLP',
  COP = 'COP',
}

export enum CountryCode {
  SG = 'SG',
  US = 'US',
  AU = 'AU',
  MY = 'MY',
  QA = 'QA',
  NZ = 'NZ',
  CA = 'CA',
  GB = 'GB',
  AE = 'AE',
  SA = 'SA',
  NL = 'NL',
  BE = 'BE',
  FR = 'FR',
  DE = 'DE',
  ES = 'ES',
  PL = 'PL',
  TR = 'TR',
  KZ = 'KZ',
  MN = 'MN',
  AZ = 'AZ',
  CH = 'CH',
  DK = 'DK',
  NO = 'NO',
  JP = 'JP',
  MX = 'MX',
  CL = 'CL',
  CO = 'CO',
}

export const CURRENCY_TO_COUNTRY: Record<CountryCode, Currency> = {
  [CountryCode.SG]: Currency.SGD,
  [CountryCode.US]: Currency.USD,
  [CountryCode.AU]: Currency.AUD,
  [CountryCode.MY]: Currency.MYR,
  [CountryCode.QA]: Currency.QAR,
  [CountryCode.NZ]: Currency.NZD,
  [CountryCode.CA]: Currency.CAD,
  [CountryCode.GB]: Currency.GBP,
  [CountryCode.AE]: Currency.AED,
  [CountryCode.SA]: Currency.SAR,
  [CountryCode.NL]: Currency.EUR,
  [CountryCode.BE]: Currency.EUR,
  [CountryCode.FR]: Currency.EUR,
  [CountryCode.DE]: Currency.EUR,
  [CountryCode.ES]: Currency.EUR,
  [CountryCode.PL]: Currency.PLN,
  [CountryCode.TR]: Currency.TRY,
  [CountryCode.KZ]: Currency.KZT,
  [CountryCode.MN]: Currency.MNT,
  [CountryCode.AZ]: Currency.AZN,
  [CountryCode.CH]: Currency.CHF,
  [CountryCode.DK]: Currency.DKK,
  [CountryCode.NO]: Currency.NOK,
  [CountryCode.JP]: Currency.JPY,
  [CountryCode.MX]: Currency.MXN,
  [CountryCode.CL]: Currency.CLP,
  [CountryCode.CO]: Currency.COP,
};
